import React from 'react';
import { Alert } from 'antd';

export default class ReportPreviewFallback extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    componentDidCatch(error, info) {
        this.setState({ hasError: true });
        console.warn(error, info, this.props);
    }
    componentDidUpdate(nextProps) {
        if (nextProps !== this.props) {
            this.setState({ hasError: false });
        }
    }
    render() {
        if (this.state.hasError) {
            const message = `We encountered an error when attempting to display the information in ${this.props.widgetblockName}`;
            return <Alert style={{ height: '100%' }} message={message} type={'error'} showIcon />;
        } else {
            return this.props.children;
        }
    }
}
